const baseRoutes = [
  {
    path: '/settings',
    component: () => import("@/_routes/settings/Root"),
  },
  {
    path: '/settings/help',
    component: () => import("@/_routes/settings/Help")
  },
  {
    path: '/settings/debug',
    component: () => import("@/_routes/settings/Debug")
  },
  {
    path: '/settings/webrtcprovider',
    component: () => import("@/_routes/settings/WebrtcProvider")
  },
  {
    path: '/settings/bookmarks',
    component: () => import("@/_routes/settings/Bookmarks")
  }
]

import accountRoutes              from '@/_routes/settings/account/_router'
import agreementRoutes            from '@/_routes/settings/agreement/_router'
const routes = baseRoutes.concat(accountRoutes)
                         .concat(agreementRoutes)

export default routes
